import LogoSrc from "@/assets/icons/logo.svg?react";
import { useSession } from "@/hooks";
import {
  useGetMeQuery,
  useGetUserFeatureFlag,
  useUpdateFeatureFlag,
} from "@/queries";
import { FeatureFlagEnum } from "@/types";
import { formatAdminRoleToName } from "@/utils";
import { PowerSettingsNew } from "@mui/icons-material";
import {
  Box,
  FormControlLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  styled,
  Switch,
} from "@mui/material";
import { FC } from "react";
import {
  AppBar,
  LogoutClasses,
  TitlePortal,
  useRedirect,
  UserMenu,
} from "react-admin";

const PREFIX = "RaLogout";

const StyledMenuItem = styled(MenuItem, {
  name: PREFIX,
  overridesResolver: (_, styles) => styles.root,
})({
  [`& .${LogoutClasses.icon}`]: {},
});

const AppBarPanel: FC = () => {
  const redirect = useRedirect();
  const { me } = useGetMeQuery();
  const { logout } = useSession();

  const { featureFlag: hiddenDeleteBtnFeatureFlag } = useGetUserFeatureFlag({
    name: FeatureFlagEnum.HIDDEN_DELETE_BUTTON,
  });
  const { updateFeatureFlag } = useUpdateFeatureFlag();

  return (
    <AppBar userMenu={false}>
      <TitlePortal />
      <LogoSrc
        style={{ cursor: "pointer" }}
        onClick={() => redirect("/users")}
      />
      <Box sx={{ flex: "1" }} />

      <FormControlLabel
        control={
          <Switch
            checked={!!hiddenDeleteBtnFeatureFlag}
            onChange={() =>
              updateFeatureFlag({
                name: FeatureFlagEnum.HIDDEN_DELETE_BUTTON,
                enabled: !hiddenDeleteBtnFeatureFlag,
              })
            }
          />
        }
        labelPlacement="start"
        label="Hide Delete"
        sx={{
          borderRight: "1px solid grey",
          justifyContent: "space-between",
          marginRight: 1,
          paddingRight: 0.5,
        }}
      />

      {me && (
        <UserMenu>
          <StyledMenuItem>
            <ListItemText>{`Email: ${me.email}`}</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem>
            <ListItemText>{`Role: ${formatAdminRoleToName(
              me.role
            )}`}</ListItemText>
          </StyledMenuItem>

          <StyledMenuItem onClick={logout}>
            <ListItemIcon className={LogoutClasses.icon}>
              <PowerSettingsNew fontSize="small" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </StyledMenuItem>
        </UserMenu>
      )}
    </AppBar>
  );
};

export { AppBarPanel };
